export const customerColorMap: { [key: string]: { color: string; text: string } } = {
  aidddo: { color: '#1d1e19', text: '#fff' },
  wjtortho: { color: '#007AC2', text: '#fff' },
  luttermann: { color: '#204a9e', text: '#fff' },
  bayer: { color: '#0dade6', text: '#fff' },
  festwood: { color: '#9abd38', text: '#fff' },
  gzpilz: { color: '#74114d', text: '#fff' },
  sunfence: { color: '#f9b637', text: '#fff' },
  spoerer: { color: '#0085ce', text: '#fff' },
};

export const defaultLogoPath = '/assets/logo_cekoon.png';
export const defaultLogoPathWhite = '/assets/cekoon_logo.png';

